import { API_ENDPOINT_USERLOGIN, API_ENDPOINT_USERREGISTER, HEADERS } from './Constants.js';
import { toast } from 'react-toastify';

export default class Users {
  userType = "TRD"; // AH-auction house, TRD- trader

  constructor() {
    this.currentUser();
  }

  async login(user) {
    //window.alert("HyperUsers Login to API users.js");
    try {
      const response = await fetch(API_ENDPOINT_USERLOGIN, {
        headers: HEADERS(),
        method: 'POST',
        body: JSON.stringify({ org: "org1", ...user }),
      });
     // window.alert("res: " + JSON.stringify(response.message));
      if (response.status !== 200) {
        //window.alert('Login failed');
        const errorData = await response.json();
        throw new Error(errorData.message || response.statusText);
      }

      const data = await response.json();
      // console.log("We are logged in and setting local storage!!!", data);
      // localStorage.setItem('mieToken', data.accessToken);
      //localStorage.setItem('mieDisplayName', data.username);
      // localStorage.setItem('userType', data.userType);
      //  console.log("We are logged in and going to set local storage. Here is the raw response from contract: ", data);
      //localStorage.setItem('userSession', JSON.stringify(data));
      this.setUserType(data.userType);
      //window.alert("data: " + JSON.stringify(data));
      // Return the user data to be used by the calling component
      return data;
    } catch (err) {
      window.alert("error: " + err.message);
      toast.dismiss();
      toast.error(err.message || err, {
        autoClose: 30000, // 30 seconds
      });
      window.alert("error: " + err.message);
      throw err;
    }
  }

  async createNewUser(user) {
    try {
      const response = await fetch(API_ENDPOINT_USERREGISTER, {
        headers: HEADERS(),
        method: 'POST',
        body: JSON.stringify(user),
      });

      if (response.status !== 200) {
        const errorData = await response.json();
        throw new Error(errorData.message || response.statusText);
      }

      const data = await response.json();
      return data;
    } catch (err) {
      toast.dismiss();
      toast.error(err.message || err, {
        autoClose: 30000, // 30 seconds
      });
      throw err;
    }
  }

  setUserType(data) {
    this.userType = data.userType || "TRD";
    return this.userType;
  }

  currentUser() {
    const currentUser = JSON.parse(localStorage.getItem('userSession')) || {};
    if (currentUser && currentUser.userType) {
      this.setUserType(currentUser);
    } else {
      // Set a default user type if none is found
      this.userType = "TRD";
    }
    return currentUser;
  }

  isUserLogin() {
    const currentUser = this.currentUser();
    return !!currentUser.accessToken;
  }
}
